<script setup>

import { storeToRefs } from 'pinia';
import {useLoadingStore} from '@/stores/loading.js';

const store = useLoadingStore();
const { isOpened } = storeToRefs(store);
const { show, close } = store;

</script>

<template>
  <div class="popup-wrapper" v-if="isOpened">
    <div class="popup">
      <div class="icon_progress"></div>
    </div>
  </div>

</template>

<style scoped>
.popup-wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, .25)
}
.popup {
  padding: 16px;
  background: white;
  border-radius: 28px;
}
.icon_progress {
  width: 24px;
  height: 24px;
  background: url('@/assets/icon_loading.svg') center / 24px auto no-repeat;
  animation: spin 1s steps(8) infinite; /* 1초 동안 8단계 회전 */
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>

